var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 25.6673V12.834M2.33333 15.1673V23.334C2.33333 24.6226 3.378 25.6673 4.66666 25.6673H20.3306C22.0581 25.6673 23.5272 24.4069 23.7899 22.6995L25.0463 14.5329C25.3725 12.4127 23.7321 10.5007 21.587 10.5007H17.5C16.8557 10.5007 16.3333 9.97832 16.3333 9.33398V5.2108C16.3333 3.62198 15.0453 2.33398 13.4565 2.33398C13.0776 2.33398 12.7341 2.55716 12.5802 2.90346L8.47459 12.1411C8.28734 12.5625 7.86953 12.834 7.40848 12.834H4.66666C3.378 12.834 2.33333 13.8787 2.33333 15.1673Z",
    stroke: "#067647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.e12b895c3b50183370dae71044d24e36.svg";
export { ForwardRef as ReactComponent };